export const MANUAL_PAYMENT = 'page/MANUAL_PAYMENT';
